import { AxiosResponseHeaders } from 'axios';
import { VocCodesResponseDTO, VocCode } from '../entities';

const vocCodesResponseDTOToVocCodesAdapter = (data: VocCodesResponseDTO, headers?: AxiosResponseHeaders): VocCode[] => {
  if (!data.body) {
    throw new Error('Error');
  }

  return data.body.vocCodes.map(vc => new VocCode(vc.serialNumber, vc.description, vc.shortDescription));
};

export { vocCodesResponseDTOToVocCodesAdapter };
